<template>
  <div class="avatar" :style="css">
	  <template v-if="!gravatarUrl">{{initials}}</template>    
  </div>
</template>

<script>
import helpers from '../helpers.js';
import jsmd5 from 'js-md5'
export default {
  name: 'avatar',
  props: [ 'input', 'text' ],
  computed: {

    initials(){
      if( this.text ) return this.text
      return helpers.getItemInitials(this.input)
    },

    bg_color()
    {
      //console.log(this.input)
      if( this.input && this.input.color ) return this.input.color
      if( this.text ) return helpers.getColorByString( this.text )
      return helpers.getColorByString( this.initials )
    },

    gravatarUrl()
    {
      if( !this.input ) return
      if( !this.input.email ) return
      var email = this.input.email
      var baseurl = 'https://www.gravatar.com/avatar/'
      var md5_email = jsmd5(email)
      var size = '?s=' + 150
      return baseurl + md5_email + size
		},

    css()
    {
      //this.bg_color
      //if(bgcolor) bgcolor = this.addSaturation(bgcolor, 4)
      var css = {}
      css['background-color'] = this.bg_color
      css['color'] = 'white'
      if( this.gravatarUrl ) css['background-image'] = 'url('+this.gravatarUrl+')'
      return css
    },

  },
  methods: {


  },
}
</script>



// WEBPACK FOOTER //
// Avatar.vue?6cda35b2